"use client";

import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { useMemo } from "react";

// BDT office location (same as Angular contact-map)
const CENTER = { lat: 44.416243, lng: 26.1321428 };
const CONTAINER_STYLE = { width: "100%", height: "510px" };
const DEFAULT_ZOOM = 12;
const MAP_OPTIONS: google.maps.MapOptions = {
	zoom: DEFAULT_ZOOM,
	mapTypeId: "roadmap",
	scrollwheel: false,
	disableDefaultUI: false,
	zoomControl: true,
};

export default function ContactMap() {
	const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;

	const { isLoaded, loadError } = useJsApiLoader({
		id: "google-map-contact",
		googleMapsApiKey: apiKey ?? "",
	});

	const options = useMemo(() => MAP_OPTIONS, []);

	if (!apiKey) {
		// Fallback: embed iframe when no API key (e.g. missing env)
		return (
			<div className="w-full min-h-[510px] rounded-lg overflow-hidden">
				<iframe
					title="BDT location"
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2847.8524458316246!2d26.096773515822393!3d44.45667430809224!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1f8ac92b00001%3A0x63319047c3d2319!2sBusiness%20Development%20Together!5e0!3m2!1sro!2sro!4v1653412579124!5m2!1sro!2sro"
					width="100%"
					height="510"
					style={{ border: 0 }}
					allowFullScreen
					loading="lazy"
					referrerPolicy="no-referrer-when-downgrade"
				/>
			</div>
		);
	}

	if (loadError) {
		if (process.env.NODE_ENV === "development") {
			console.error("Google Maps load error:", loadError);
		}
		// Fallback to embed iframe when JS API fails (e.g. invalid key, CSP, or network)
		return (
			<div className="w-full min-h-[510px] rounded-lg overflow-hidden">
				<iframe
					title="BDT location"
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2847.8524458316246!2d26.096773515822393!3d44.45667430809224!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1f8ac92b00001%3A0x63319047c3d2319!2sBusiness%20Development%20Together!5e0!3m2!1sro!2sro!4v1653412579124!5m2!1sro!2sro"
					width="100%"
					height="510"
					style={{ border: 0 }}
					allowFullScreen
					loading="lazy"
					referrerPolicy="no-referrer-when-downgrade"
				/>
			</div>
		);
	}

	if (!isLoaded) {
		return (
			<div className="w-full h-[510px] rounded-lg bg-[#eee] flex items-center justify-center text-gray-600">
				Loading map…
			</div>
		);
	}

	return (
		<div className="w-full min-h-[510px] rounded-lg overflow-hidden">
			<GoogleMap
				mapContainerStyle={CONTAINER_STYLE}
				center={CENTER}
				zoom={MAP_OPTIONS.zoom ?? DEFAULT_ZOOM}
				options={options}
			>
				<Marker position={CENTER} />
			</GoogleMap>
		</div>
	);
}
